import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const CATS_URL = `${process.env.REACT_APP_API_BASE_URL}/public/categories`;

export const fetchCategories = createAsyncThunk(
    "categories/fetchAll",
    async () => {
        const { data } = await axios.get(CATS_URL);
        return Array.isArray(data) ? data : [];
    },
    {
        condition: (_, { getState }) => {
            const { status, items } = getState().categories || {};
            if (status === "loading" || (items && items.length)) return false;
            return true;
        },
    }
);

const categoriesSlice = createSlice({
    name: "categories",
    initialState: {
        items: [],
        status: "idle", // idle | loading | succeeded | failed
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategories.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.items = action.payload;
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error?.message || "Unknown error";
            });
    },
});

export const categoriesReducer = categoriesSlice.reducer;

export const selectCategories = (state) => state.categories.items;
export const selectCategoriesStatus = (state) => state.categories.status;
export const selectCategoriesError = (state) => state.categories.error;
